import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/*
Fires when the User clicks on the Volume button and the Volume change has been made.
This Event should fire no matter how the user changes the volume, whether through the
system control or through the app controls.
 */

export const clickVolumeBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.INTERACT,
  eventName: EVENT_NAMES.CLICK_VOLUME,
  label: action.payload.up ? 'up' : 'down',
  value: action.payload.level,
});
